import React, { useEffect, useState } from 'react'
import { 
	SimpleForm, 
	TextInput, 
	BooleanInput, 
	NumberInput,
	useRecordContext, 
	required, 
	SelectInput, 
	useNotify, 
	useTranslate, 
	Edit, 
	FormDataConsumer,
	useDataProvider,
    GET_LIST 
} from 'react-admin'
import { Navigate, useNavigate, useLocation  } from 'react-router-dom'

export const FieldType = {
	text: 'text',
	number: 'number',
	boolean: 'boolean',
	textArea: 'textArea',
	email: 'email',
	custom: 'custom',
	budget: 'budget',
}

const c = [
	{ id: 'text', name: 'text' },
	{ id: 'number', name: 'number' },
	{ id: 'boolean', name: 'boolean' },
	{ id: 'textArea', name: 'textArea' },
	{ id: 'email', name: 'email' },
	{ id: 'custom', name: 'custom' },
	{ id: 'budget', name: 'budget' },
]

const OrderSettingsEdit = props => {
  const record = useRecordContext();
   const location = useLocation()
  const translate = useTranslate()
  const navigate = useNavigate();
  const notify = useNotify()
  const restProvider = useDataProvider()
  const [settingsList, setSettingsList] = useState([])
  
  const { org_id, system_id } = location.state || {}
  const onSuccess = () => {
    notify(translate("customRoot.upload.successMessage"), { type: "success" })
    navigate('/order_settings');
  }

  const updateClList = (hasBudgetField) => {
	const fieldList = settingsList.filter(field => field.fieldType == "budget")
	if (fieldList.length > 0) {
		if (hasBudgetField) {
			return [
			  { id: 'text', name: 'text' },
			  { id: 'number', name: 'number' },
			  { id: 'boolean', name: 'boolean' },
			  { id: 'textArea', name: 'textArea' },
			  { id: 'email', name: 'email' },
			  { id: 'custom', name: 'custom' },
			  { id: 'budget', name: 'budget' },
			]
		} else {
			return [
				{ id: 'text', name: 'text' },
				{ id: 'number', name: 'number' },
				{ id: 'boolean', name: 'boolean' },
				{ id: 'textArea', name: 'textArea' },
				{ id: 'email', name: 'email' },
				{ id: 'custom', name: 'custom' },
			  ]
		}
	} else {
		return [
			{ id: 'text', name: 'text' },
			{ id: 'number', name: 'number' },
			{ id: 'boolean', name: 'boolean' },
			{ id: 'textArea', name: 'textArea' },
			{ id: 'email', name: 'email' },
			{ id: 'custom', name: 'custom' },
			{ id: 'budget', name: 'budget' },
		  ]
	}
  }

  useEffect(() => {
	restProvider(GET_LIST, 'order_settings', { filter: { org_id, system_id }, pagination: {page:1,perPage:25}, sort: {field: "id", order: "ASC"} })
	  .then(res => {
		if (res.success) {
		  setSettingsList(res.data)
		}
	  })
  }, [])
		
  if (!system_id) return <Navigate to='/order_settings' />
	
  return (
	<Edit {...props} mutationMode="pessimistic" title='resources.items.name' mutationOptions={{ onSuccess }} queryOptions={{ meta: {org_id, system_id} }}>
			<SimpleForm>
			  <FormDataConsumer>
			  {({ formData }) =>
				<>
			      {org_id && <TextInput source='org_id' label='resources.organizations.singular' validate={required()} defaultValue={org_id} disabled />}
				  {system_id && <TextInput source='system_id' label='resources.systems.singular' validate={required()} defaultValue={system_id} disabled />}
				  <TextInput source='id' label='customRoot.order_settings.id' validate={required()} helperText='customRoot.order_settings.id_helper' disabled={true} />
				  <TextInput source='name' label='customRoot.order_settings.name' validate={required()} />
				  <TextInput source='placeholder' label='customRoot.order_settings.placeholder' />
				  <NumberInput source='sortNumber' label='customRoot.order_settings.sortNumber' validate={required()} />
				  <SelectInput 
				    source='fieldType' 
					label='customRoot.order_settings.fieldType' 
					disabled={'fieldType' in formData && formData.fieldType == "budget"} 
					choices={updateClList('fieldType' in formData && formData.fieldType == "budget")}  
					validate={required()} />
				  <BooleanInput source='isRequired' label='customRoot.order_settings.isRequired'  defaultValue={false} />
				</>
				}
				</FormDataConsumer>
			</SimpleForm>
		</Edit>
  )
}

export default OrderSettingsEdit
